<template>
  <div class="page-wrapper tc-history">
    <!-- Lightbox ảnh -->
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImgs"
      :index="lightboxIndex"
      @hide="onHideLightbox"
    ></vue-easy-lightbox>

    <div class="content container-fluid">

      <!-- Header -->
      <div class="tc-hdr">
        <div class="tc-title">Sổ giao dịch</div>
        <div class="tc-subtitle">Lịch sử thu chi cá nhân</div>
      </div>

      <!-- Bộ lọc -->
      <div class="tc-filter-card">
        <!-- Hàng 1: loại + trạng thái -->
        <div class="tc-filter-row">
          <div class="btn-group btn-group-sm mr-2" role="group">
            <button
              v-for="opt in loaiOptions"
              :key="opt.value"
              type="button"
              class="btn tc-pill-btn"
              :class="{ active: filterLoai === opt.value }"
              @click="setFilterLoai(opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>

          <select
            class="form-control form-control-sm tc-select-status"
            v-model="filterTrangThai"
            @change="reload"
          >
            <option v-for="opt in trangThaiOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!-- Hàng 2: khoảng ngày -->
        <div class="tc-filter-row mt-2">
          <div class="tc-date-range">
            <div class="tc-date-input" @click="openDatePicker('from')">
              <span>Từ</span>
              <strong>{{ formatDateLabel(tuNgay) }}</strong>
            </div>
            <div class="tc-date-input" @click="openDatePicker('to')">
              <span>Đến</span>
              <strong>{{ formatDateLabel(denNgay) }}</strong>
            </div>
          </div>

          <div class="tc-quick-range">
            <button
              type="button"
              class="btn btn-xs btn-outline-secondary mr-1"
              @click="setThangNay"
            >
              Tháng này
            </button>
            <button
              type="button"
              class="btn btn-xs btn-outline-secondary"
              @click="setThangTruoc"
            >
              Tháng trước
            </button>
          </div>
        </div>

        <!-- Hàng 3: danh mục (tùy chọn) -->
        <div class="tc-filter-row mt-2">
          <select
            class="form-control form-control-sm"
            v-model="filterDanhMucId"
            @change="reload"
          >
            <option :value="null">Tất cả danh mục</option>
            <option
              v-for="dm in danhMucFilterList"
              :key="dm.id"
              :value="dm.id"
            >
              {{ dm.tenDanhMuc }}
            </option>
          </select>
        </div>

        <!-- input date ẩn -->
        <input
          ref="dateFromInput"
          type="date"
          class="d-none"
          v-model="tuNgay"
          @change="reload"
        />
        <input
          ref="dateToInput"
          type="date"
          class="d-none"
          v-model="denNgay"
          @change="reload"
        />
      </div>

      <!-- Danh sách -->
      <div class="tc-list-card">
        <div v-if="loading" class="text-center text-muted py-3">
          Đang tải dữ liệu...
        </div>

        <div v-else-if="items.length === 0" class="text-center text-muted py-4">
          Không có giao dịch nào trong khoảng đã chọn.
        </div>

        <div v-else>
          <div
            v-for="item in items"
            :key="item.id"
            class="tc-item"
            @click="openDetail(item)"
          >
            <div class="tc-item-left">
              <div class="tc-item-icon">
                <img
                  v-if="item.iconDanhMucUrl"
                  :src="item.iconDanhMucUrl"
                  alt="icon"
                  @error="onIconError($event)"
                />
                <span v-else>{{ item.tenDanhMuc?.charAt(0) }}</span>
              </div>
              <div class="tc-item-main">
                <div class="tc-item-title">
                  {{ item.tenDanhMuc }}
                </div>
                <div class="tc-item-sub">
                  <span>{{ formatNgay(item.ngayGiaoDich) }}</span>
                  <span v-if="item.ghiChu" class="tc-item-note">
                    • {{ item.ghiChu }}
                  </span>
                </div>
              </div>
            </div>

            <div class="tc-item-right">
              <div
                class="tc-item-money"
                :class="{ chi: item.loai === 'CHI', thu: item.loai === 'THU' }"
              >
                {{ item.loai === 'CHI' ? '-' : '+' }}
                {{ formatMoney(item.soTien) }}
              </div>
              <div class="tc-item-status" :class="statusClass(item.trangThai)">
                {{ statusLabel(item.trangThai) }}
              </div>

              <button
                v-if="canDelete(item)"
                type="button"
                class="tc-item-delete"
                @click.stop="confirmDelete(item)"
                title="Xóa phiếu"
              >
                <i class="la la-trash"></i>
              </button>
            </div>
          </div>

          <div v-if="hasMore" class="text-center mt-2">
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              :disabled="loadingMore"
              @click="loadMore"
            >
              <span v-if="!loadingMore">Xem thêm</span>
              <span v-else>Đang tải...</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Modal chi tiết -->
      <div v-if="showDetail" class="modal-backdrop fade show"></div>
      <div v-if="showDetail" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Chi tiết {{ detail?.loai === 'CHI' ? 'chi tiêu' : 'thu nhập' }}
              </h5>
              <button type="button" class="close" @click="closeDetail">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="detail">
              <p class="mb-1">
                <strong>Ngày:</strong> {{ formatNgay(detail.ngayGiaoDich) }}
              </p>
              <p class="mb-1">
                <strong>Danh mục:</strong> {{ detail.tenDanhMuc }}
              </p>
              <p class="mb-1">
                <strong>Số tiền:</strong>
                <span :class="detail.loai === 'CHI' ? 'text-danger' : 'text-success'">
                  {{ detail.loai === 'CHI' ? '-' : '+' }}
                  {{ formatMoney(detail.soTien) }} đ
                </span>
              </p>
              <p class="mb-1">
                <strong>Trạng thái:</strong> {{ statusLabel(detail.trangThai) }}
              </p>
              <p class="mb-1" v-if="detail.huongXuLy">
                <strong>Hướng xử lý:</strong> {{ huongXuLyLabel(detail.huongXuLy) }}
              </p>
              <p class="mb-1" v-if="detail.ghiChu">
                <strong>Ghi chú:</strong> {{ detail.ghiChu }}
              </p>

              <!-- ảnh hoá đơn -->
              <div v-if="detail.dsAnhHoaDon?.length" class="mt-2">
                <strong>Ảnh hoá đơn:</strong>
                <div class="tc-detail-images">
                  <button
                    v-for="(img, idx) in detail.dsAnhHoaDon"
                    :key="idx"
                    type="button"
                    class="tc-thumb-btn"
                    @click="openLightbox(normalizeImgArray(detail.dsAnhHoaDon), idx)"
                  >
                    <img :src="getImgUrl(img)" alt="hoa don" />
                  </button>
                </div>
              </div>

              <!-- ảnh thanh toán -->
              <div v-if="detail.dsAnhThanhToan?.length" class="mt-2">
                <strong>Ảnh thanh toán:</strong>
                <div class="tc-detail-images">
                  <button
                    v-for="(img, idx) in detail.dsAnhThanhToan"
                    :key="idx"
                    type="button"
                    class="tc-thumb-btn"
                    @click="openLightbox(normalizeImgArray(detail.dsAnhThanhToan), idx)"
                  >
                    <img :src="getImgUrl(img)" alt="thanh toan" />
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                v-if="detail && canDelete(detail)"
                type="button"
                class="btn btn-danger mr-auto"
                @click="confirmDelete(detail, true)"
              >
                <i class="la la-trash mr-1"></i>
                Xóa phiếu
              </button>
              <button type="button" class="btn btn-secondary" @click="closeDetail">
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import api from "@/api/index.js"
import { useToast } from "vue-toastification"
import Swal from "sweetalert2"
import VueEasyLightbox from 'vue-easy-lightbox'
const toast = useToast()

// ===== Lightbox state =====
const lightboxVisible = ref(false)
const lightboxImgs = ref([])
const lightboxIndex = ref(0)

// hỗ trợ cả dạng string và object
function getImgUrl(img) {
  if (!img) return ""
  if (typeof img === "string") return img
  return img.url || img.filePath || img.location || ""
}

function normalizeImgArray(arr) {
  if (!Array.isArray(arr)) return []
  return arr
    .map(getImgUrl)
    .filter(u => !!u)
}

function openLightbox(imgUrls, startIndex = 0) {
  lightboxImgs.value = imgUrls || []
  lightboxIndex.value = startIndex || 0
  lightboxVisible.value = true
}

function onHideLightbox() {
  lightboxVisible.value = false
}

// ===== Filter state =====
const loaiOptions = [
  { value: "ALL", label: "Tất cả" },
  { value: "CHI", label: "Chi" },
  { value: "THU", label: "Thu" }
]

const trangThaiOptions = [
  { value: "ALL", label: "Tất cả trạng thái" },
  { value: "CHO_DUYET", label: "Chờ duyệt" },
  { value: "DA_DUYET", label: "Đã duyệt" },
  { value: "DA_THANH_TOAN", label: "Đã thanh toán" },
  { value: "DA_QUYET_TOAN", label: "Đã quyết toán" },
  { value: "TU_CHOI", label: "Từ chối" }
]

const filterLoai = ref("ALL")
const filterTrangThai = ref("ALL")
const filterDanhMucId = ref(null)

// ngày
const tuNgay = ref("")
const denNgay = ref("")

const dateFromInput = ref(null)
const dateToInput = ref(null)

// danh mục cho dropdown filter
const danhMucFilterList = ref([])

// ===== List state =====
const items = ref([])
const page = ref(0)
const size = ref(20)
const hasMore = ref(false)
const loading = ref(false)
const loadingMore = ref(false)

// ===== Detail modal =====
const showDetail = ref(false)
const detail = ref(null)

// ===== utils =====
function setThangNay() {
  const now = new Date()
  const y = now.getFullYear()
  const m = now.getMonth()
  const first = new Date(y, m, 1)
  const last = new Date(y, m + 1, 0)
  tuNgay.value = toISODate(first)
  denNgay.value = toISODate(last)
  reload()
}

function setThangTruoc() {
  const now = new Date()
  const y = now.getFullYear()
  const m = now.getMonth() - 1
  const first = new Date(y, m, 1)
  const last = new Date(y, m + 1, 0)
  tuNgay.value = toISODate(first)
  denNgay.value = toISODate(last)
  reload()
}

function toISODate(d) {
  const off = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
  return off.toISOString().slice(0, 10)
}

function formatDateLabel(v) {
  if (!v) return ""
  const d = new Date(v + "T00:00:00")
  const dd = ("0" + d.getDate()).slice(-2)
  const mm = ("0" + (d.getMonth() + 1)).slice(-2)
  const yyyy = d.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

function openDatePicker(which) {
  if (which === "from" && dateFromInput.value) {
    dateFromInput.value.showPicker
      ? dateFromInput.value.showPicker()
      : dateFromInput.value.click()
  } else if (which === "to" && dateToInput.value) {
    dateToInput.value.showPicker
      ? dateToInput.value.showPicker()
      : dateToInput.value.click()
  }
}

function setFilterLoai(value) {
  filterLoai.value = value
  loadDanhMucFilter()
  reload()
}

// ===== Định dạng =====
function formatNgay(ngayStr) {
  if (!ngayStr) return ""
  return formatDateLabel(ngayStr)
}

function formatMoney(v) {
  if (v == null) return "0"
  const num = typeof v === "number" ? v : Number(v)
  if (Number.isNaN(num)) return "0"
  return num.toLocaleString("vi-VN")
}

function statusLabel(st) {
  switch (st) {
    case "CHO_DUYET": return "Chờ duyệt"
    case "DA_DUYET": return "Đã duyệt"
    case "DA_THANH_TOAN": return "Đã thanh toán"
    case "DA_QUYET_TOAN": return "Đã quyết toán"
    case "TU_CHOI": return "Từ chối"
    default: return st || ""
  }
}

function statusClass(st) {
  return {
    "st-cho-duyet": st === "CHO_DUYET",
    "st-da-duyet": st === "DA_DUYET",
    "st-da-thanh-toan": st === "DA_THANH_TOAN",
    "st-da-quyet-toan": st === "DA_QUYET_TOAN",
    "st-tu-choi": st === "TU_CHOI"
  }
}

function huongXuLyLabel(h) {
  switch (h) {
    case "QUA_LUONG": return "Qua lương (cộng/trừ)"
    case "TRA_NONG": return "Trả nóng"
    case "TRU_LUONG": return "Trừ lương"
    case "NOP_NGAY": return "Nộp lại ngay"
    default: return h || ""
  }
}

function onIconError(e) {
  e.target.style.display = "none"
}

// ===== Load danh mục filter theo loại =====
async function loadDanhMucFilter() {
  try {
    danhMucFilterList.value = []
    filterDanhMucId.value = null

    // nếu ALL thì không filter danh mục (list empty => chỉ option "Tất cả")
    if (filterLoai.value === "ALL") {
      return
    }

    const res = await api.get("/api/thu-chi/danh-muc", {
      params: { loai: filterLoai.value }
    })
    danhMucFilterList.value = res.data || []
  } catch (e) {
    console.error(e)
  }
}

// ===== Load data =====
async function fetchData(reset = false) {
  if (reset) {
    page.value = 0
    items.value = []
    hasMore.value = false
  }

  const params = {
    page: page.value,
    size: size.value,
    tuNgay: tuNgay.value,
    denNgay: denNgay.value
  }

  if (filterLoai.value !== "ALL") {
    params.loai = filterLoai.value
  }
  if (filterTrangThai.value !== "ALL") {
    params.trangThai = filterTrangThai.value
  }
  if (filterDanhMucId.value) {
    params.idDanhMuc = filterDanhMucId.value
  }

  try {
    if (reset) {
      loading.value = true
    } else {
      loadingMore.value = true
    }

    const res = await api.get("/api/thu-chi/my", { params })
    const pageData = res.data || {}
    const content = pageData.content || []

    if (reset) {
      items.value = content
    } else {
      items.value = items.value.concat(content)
    }

    const totalPages = pageData.totalPages ?? 0
    hasMore.value = page.value + 1 < totalPages
  } catch (e) {
    console.error(e)
    toast.error("Không tải được sổ giao dịch")
  } finally {
    loading.value = false
    loadingMore.value = false
  }
}

function reload() {
  fetchData(true)
}

function loadMore() {
  if (hasMore.value && !loadingMore.value) {
    page.value += 1
    fetchData(false)
  }
}

// ===== Detail =====
async function openDetail(item) {
  try {
    const res = await api.get(`/api/thu-chi/my/${item.id}`)
    detail.value = res.data
    showDetail.value = true
  } catch (e) {
    console.error(e)
    toast.error("Không lấy được chi tiết giao dịch")
  }
}

function closeDetail() {
  showDetail.value = false
  detail.value = null
}

// ===== Delete (xóa mềm) =====
function canDelete(item) {
  if (!item) return false
  // cho phép xóa khi còn chờ duyệt (logic mềm, BE vẫn check lại)
  return item.trangThai === "CHO_DUYET"
}

async function confirmDelete(item, fromDetail = false) {
  if (!item) return

  const result = await Swal.fire({
    title: "Xóa phiếu thu chi?",
    text: "Phiếu sẽ được xóa mềm và không còn hiển thị trong sổ giao dịch của bạn.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Xóa",
    cancelButtonText: "Hủy"
  })

  if (!result.isConfirmed) return

  try {
    await api.delete(`/api/thu-chi/my/${item.id}`)
    toast.success("Đã xóa phiếu thu chi")

    items.value = items.value.filter(x => x.id !== item.id)

    if (fromDetail) {
      closeDetail()
    }
  } catch (e) {
    console.error(e)
    toast.error("Xóa phiếu thu chi thất bại")
  }
}

// ===== lifecycle =====
onMounted(() => {
  setThangNay()       // sẽ gọi reload()
  loadDanhMucFilter() // filter mặc định ALL
})
</script>

<style scoped>
.tc-history {
  background: #f6f8fb;
  max-width: 480px;
  margin: 0 auto;
}

/* header */
.tc-hdr {
  padding: 4px 2px 6px;
}

.tc-title {
  font-weight: 600;
  font-size: 18px;
}

.tc-subtitle {
  font-size: 12px;
  color: #888;
}

/* filter card */
.tc-filter-card {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
  margin-bottom: 10px;
}

.tc-filter-row {
  display: flex;
  align-items: center;
}

/* pill type */
.tc-pill-btn {
  background: #f3f3f3;
  border-radius: 999px;
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  color: #666;
}

.tc-pill-btn.active {
  background: #ff8b00;
  color: #fff;
}

.tc-select-status {
  min-width: 140px;
}

/* date range */
.tc-date-range {
  display: flex;
  flex: 1;
  gap: 4px;
}

.tc-date-input {
  flex: 1;
  border-radius: 8px;
  background: #f5f5f5;
  padding: 4px 8px;
  font-size: 11px;
  cursor: pointer;
}

.tc-date-input span {
  display: block;
  color: #999;
}

.tc-date-input strong {
  font-size: 12px;
  color: #333;
}

.tc-quick-range {
  margin-left: 6px;
  white-space: nowrap;
}

.btn-xs {
  padding: 2px 8px;
  font-size: 11px;
}

/* list */
.tc-list-card {
  background: #fff;
  border-radius: 10px;
  padding: 6px 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}

/* item */
.tc-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}

.tc-item:last-child {
  border-bottom: none;
}

.tc-item-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.tc-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fff8ec;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.tc-item-icon img {
  max-width: 100%;
  max-height: 100%;
}

.tc-item-icon span {
  font-weight: 600;
  color: #ff8b00;
}

.tc-item-main {
  min-width: 0;
}

.tc-item-title {
  font-size: 13px;
  font-weight: 600;
}

.tc-item-sub {
  font-size: 11px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tc-item-note {
  margin-left: 2px;
}

/* right */
.tc-item-right {
  text-align: right;
  margin-left: 8px;
  position: relative;
}

.tc-item-money {
  font-size: 13px;
  font-weight: 600;
}

.tc-item-money.chi {
  color: #e53935;
}

.tc-item-money.thu {
  color: #43a047;
}

/* status chip */
.tc-item-status {
  margin-top: 2px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  display: inline-block;
}

.st-cho-duyet {
  background: #fff3cd;
  color: #856404;
}

.st-da-duyet {
  background: #e3f2fd;
  color: #1565c0;
}

.st-da-thanh-toan {
  background: #e8f5e9;
  color: #2e7d32;
}

.st-da-quyet-toan {
  background: #ede7f6;
  color: #5e35b1;
}

.st-tu-choi {
  background: #ffebee;
  color: #c62828;
}

/* nút xóa */
.tc-item-delete {
  margin-top: 2px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  color: #e53935;
}

/* detail modal images + thumb */
.tc-detail-images {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.tc-thumb-btn {
  border: none;
  padding: 0;
  background: transparent;
}

.tc-thumb-btn img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #eee;
}
.btn-group.btn-group-sm.mr-2
 {
    width: 80% !important;
}

.tc-history {
  background: #f6f8fb;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

/* Tablet */
@media (min-width: 768px) {
  .tc-history {
    max-width: 720px;
  }

  .tc-filter-card {
    padding: 16px;
  }

  .tc-item {
    padding: 12px 16px;
  }
}

/* Desktop */
@media (min-width: 1200px) {
  .tc-history {
    max-width: 800px;
  }

  .tc-filter-card {
    padding: 20px;
  }

  .tc-item {
    padding: 14px 20px;
  }

  .tc-item:hover {
    background-color: #f8f9fa;
  }
}

/* Điều chỉnh bộ lọc cho mobile */
@media (max-width: 767px) {
  .tc-filter-row {
    flex-direction: column;
    gap: 8px;
  }

  .tc-date-range {
    width: 100%;
  }

  .tc-quick-range {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
